document.documentElement.classList.add('js', 'js-enabled');
if (window.Shopify && Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');
const header = document.querySelector('[data-site-header]');
const updateHeaderHeight = () => {
  if (!header) return;
  const rect = header.getBoundingClientRect();
  const height = Math.round(rect.height || header.offsetHeight || 0);
  if (height > 0) {
    document.documentElement.style.setProperty('--site-header-height', `${height}px`);
  }
};
if (header) {
  updateHeaderHeight();
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(() => updateHeaderHeight()).observe(header);
  }
  window.addEventListener('load', updateHeaderHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderHeight);
  }
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 20), { passive: true });
}
const navToggle=document.querySelector('[data-nav-toggle]');
const nav=document.querySelector('[data-main-nav]');
if(navToggle&&nav)navToggle.addEventListener('click',()=>{const open=nav.classList.toggle('open');navToggle.setAttribute('aria-expanded',String(open));});
document.querySelectorAll('[data-submenu-toggle]').forEach(toggle=>toggle.addEventListener('click',()=>{const item=toggle.closest('.main-nav-item');const open=item.classList.toggle('submenu-open');toggle.setAttribute('aria-expanded',String(open));}));
document.querySelectorAll('[data-lang-switcher]').forEach(switcher=>{const toggle=switcher.querySelector('[data-lang-toggle]');if(!toggle)return;toggle.addEventListener('click',()=>{const open=switcher.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));});document.addEventListener('click',event=>{if(!switcher.contains(event.target)){switcher.classList.remove('open');toggle.setAttribute('aria-expanded','false');}});});
class ProductRecommendations extends HTMLElement{connectedCallback(){fetch(this.dataset.url).then(r=>r.ok?r.text():Promise.reject(new Error('recommendations request failed'))).then(t=>{const html=document.createElement('div');html.innerHTML=t;const recs=html.querySelector('product-recommendations');if(recs&&recs.innerHTML.trim().length){this.innerHTML=recs.innerHTML;}}).catch(()=>{});}}
customElements.define('product-recommendations',ProductRecommendations);

document.querySelectorAll('[data-collection-section]').forEach(section=>{
  const facets=section.querySelector('[data-facets]');
  const open=section.querySelector('[data-facets-open]');
  const close=section.querySelector('[data-facets-close]');
  if(facets&&open){open.addEventListener('click',()=>{facets.hidden=false;open.setAttribute('aria-expanded','true');});close?.addEventListener('click',()=>{facets.hidden=true;open.setAttribute('aria-expanded','false');});}
  const form=section.querySelector('[data-facets-form]');
  const filterToggle=section.querySelector('[data-collection-filter-toggle]');
  if(filterToggle&&form){
    filterToggle.addEventListener('click',()=>{
      const expanded=filterToggle.getAttribute('aria-expanded')==='true';
      filterToggle.setAttribute('aria-expanded',String(!expanded));
      form.classList.toggle('is-open-mobile',!expanded);
    });
  }
  const typeInputs=[...section.querySelectorAll('input[name="filter.p.product_type"]')];
  typeInputs.forEach(input=>input.addEventListener('change',()=>form?.requestSubmit()));
  form?.addEventListener('submit',event=>{
    event.preventDefault();
    const url=new URL(window.location.href);
    const fieldNames=[...form.elements].filter(field=>field.name).map(field=>field.name);
    [...new Set(fieldNames)].forEach(name=>url.searchParams.delete(name));
    new FormData(form).forEach((value,name)=>{if(String(value).trim()!=='')url.searchParams.append(name,value);});
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
  section.querySelectorAll('[data-collection-sort]').forEach(control=>{
    const trigger=control.querySelector('[data-collection-sort-trigger]');
    const menu=control.querySelector('[data-collection-sort-menu]');
    const options=[...control.querySelectorAll('[data-collection-sort-option]')];
    if(!trigger||!menu||!options.length)return;
    const positionMenu=()=>{
      if(menu.hidden)return;
      menu.dataset.placement='bottom';
      menu.style.removeProperty('max-height');
      const safetyMargin=16;
      const triggerRect=trigger.getBoundingClientRect();
      const menuHeight=menu.scrollHeight;
      const spaceBelow=window.innerHeight-triggerRect.bottom-safetyMargin;
      const spaceAbove=triggerRect.top-safetyMargin;
      const placement=spaceBelow>=menuHeight?'bottom':spaceAbove>spaceBelow?'top':'bottom';
      const availableSpace=Math.max(0,placement==='bottom'?spaceBelow:spaceAbove);
      menu.dataset.placement=placement;
      menu.style.maxHeight=`${availableSpace}px`;
    };
    const closeMenu=()=>{menu.hidden=true;trigger.setAttribute('aria-expanded','false');menu.removeAttribute('data-placement');menu.style.removeProperty('max-height');};
    const openMenu=()=>{menu.hidden=false;trigger.setAttribute('aria-expanded','true');positionMenu();};
    trigger.addEventListener('click',()=>menu.hidden?openMenu():closeMenu());
    options.forEach(option=>option.addEventListener('click',()=>{
      const url=new URL(window.location.href);
      url.searchParams.set('sort_by',option.dataset.sortValue);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }));
    control.addEventListener('keydown',event=>{
      if(event.key==='Escape'){closeMenu();trigger.focus();return;}
      if(menu.hidden||!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
      event.preventDefault();
      const activeIndex=Math.max(0,options.indexOf(document.activeElement));
      const nextIndex=event.key==='ArrowDown'?Math.min(options.length-1,activeIndex+1):event.key==='ArrowUp'?Math.max(0,activeIndex-1):event.key==='Home'?0:options.length-1;
      options[nextIndex].focus();
    });
    document.addEventListener('pointerdown',event=>{if(!control.contains(event.target))closeMenu();});
    window.addEventListener('resize',positionMenu);
    window.addEventListener('scroll',positionMenu,{passive:true});
  });
});

function initProductDetail(section) {
  if (!section || section.dataset.productDetailInitialized === 'true') return;
  section.dataset.productDetailInitialized = 'true';

  const gallery = section.querySelector('[data-product-gallery]');
  const main = gallery?.querySelector('[data-main-media]');
  const thumbs = [...(gallery?.querySelectorAll('[data-gallery-thumb]') || [])];
  const lightbox = section.parentElement?.querySelector('[data-product-lightbox]');
  let active = Math.max(thumbs.findIndex(thumb => thumb.classList.contains('is-active')), 0);
  let touchStartX = null;
  let pointerStartX = null;

  const updateCount = () => {
    gallery?.querySelectorAll('[data-product-gallery-index]').forEach(node => { node.textContent = String(active + 1); });
    lightbox?.querySelectorAll('[data-lightbox-index]').forEach(node => { node.textContent = String(active + 1); });
  };

  const renderLightbox = () => {
    const target = lightbox?.querySelector('[data-lightbox-media]');
    const thumb = thumbs[active];
    if (!target || !thumb?.dataset.full) return;
    const image = document.createElement('img');
    image.src = thumb.dataset.full;
    image.alt = thumb.dataset.alt || '';
    target.replaceChildren(image);
    updateCount();
  };

  const setActive = index => {
    if (!thumbs.length) return;
    active = (index + thumbs.length) % thumbs.length;
    const thumb = thumbs[active];
    if (main && thumb?.dataset.full) {
      const image = document.createElement('img');
      image.src = thumb.dataset.full;
      image.alt = thumb.dataset.alt || '';
      image.loading = 'eager';
      main.replaceChildren(image);
    }
    thumbs.forEach((item, position) => {
      const isActive = position === active;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', String(isActive));
    });
    const nextThumb = thumbs[(active + 1) % thumbs.length];
    if (nextThumb?.dataset.full) {
      const preload = new Image();
      preload.src = nextThumb.dataset.full;
    }
    if (lightbox && !lightbox.hidden) renderLightbox();
    updateCount();
  };

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    main?.focus();
  };

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => setActive(index)));
  gallery?.querySelector('[data-gallery-previous]')?.addEventListener('click', () => setActive(active - 1));
  gallery?.querySelector('[data-gallery-next]')?.addEventListener('click', () => setActive(active + 1));
  main?.addEventListener('click', () => {
    if (!lightbox) return;
    renderLightbox();
    lightbox.hidden = false;
    lightbox.querySelector('[data-lightbox-close]')?.focus();
  });
  const completeSwipe = (startX, endX) => {
    if (startX === null || endX === null || Math.abs(endX - startX) < 36) return;
    setActive(endX < startX ? active + 1 : active - 1);
  };
  const galleryStage = gallery?.querySelector('.product-gallery__stage');
  galleryStage?.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
  galleryStage?.addEventListener('touchend', event => {
    const touchEndX = event.changedTouches[0]?.clientX ?? null;
    completeSwipe(touchStartX, touchEndX);
    touchStartX = null;
  }, { passive: true });
  galleryStage?.addEventListener('pointerdown', event => { pointerStartX = event.clientX; });
  galleryStage?.addEventListener('pointerup', event => {
    completeSwipe(pointerStartX, event.clientX);
    pointerStartX = null;
  });

  lightbox?.querySelectorAll('[data-lightbox-close]').forEach(button => button.addEventListener('click', closeLightbox));
  lightbox?.querySelector('[data-lightbox-previous]')?.addEventListener('click', () => setActive(active - 1));
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => setActive(active + 1));
  document.addEventListener('keydown', event => {
    const inFormField = ['INPUT', 'SELECT', 'TEXTAREA'].includes(document.activeElement?.tagName);
    if (event.key === 'Escape' && lightbox && !lightbox.hidden) { closeLightbox(); return; }
    if (inFormField || !thumbs.length) return;
    if (event.key === 'ArrowLeft') { event.preventDefault(); setActive(active - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); setActive(active + 1); }
  });

  section.querySelectorAll('[data-product-accordion]').forEach(detail => {
    const summary = detail.querySelector('summary');
    detail.addEventListener('toggle', () => {
      summary?.setAttribute('aria-expanded', String(detail.open));
      if (detail.open) section.querySelectorAll('[data-product-accordion]').forEach(other => { if (other !== detail) other.open = false; });
    });
  });

  const variantsElement = section.parentElement?.querySelector('[data-product-variants]');
  const variants = variantsElement ? JSON.parse(variantsElement.textContent) : [];
  const stockElement = section.parentElement?.querySelector('[data-product-stock]');
  const stock = stockElement ? JSON.parse(stockElement.textContent) : {};
  const leadtime = section.querySelector('[data-product-leadtime]');
  const optionInputs = [...section.querySelectorAll('[data-variant-option]')];
  const form = section.querySelector('[data-product-form]');
  const idInput = section.querySelector('[data-variant-id]');
  const price = section.querySelector('[data-product-price]');
  const compare = section.querySelector('[data-product-compare]');
  const inventory = section.querySelector('[data-product-inventory]');
  const button = section.querySelector('[data-add-to-cart]');
  const quantity = form?.querySelector('[name="quantity"]');
  const quantityBlock = section.querySelector('[data-quantity-block]');
  const paymentBlock = section.querySelector('[data-payment-block]');
  const stickyCta = section.querySelector('[data-product-sticky-cta]');
  const stickyPrice = stickyCta?.querySelector('[data-sticky-price]');
  const stickyButton = stickyCta?.querySelector('[data-sticky-atc]');
  const formatMoney = value => new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', document.documentElement.lang === 'en' ? { style: 'currency', currency: section.dataset.productCurrency || 'USD' } : { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(value / 100);
  const updateVariant = () => {
    const selectedOptions = optionInputs.length
      ? [...section.querySelectorAll('[data-variant-option]:checked')].sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)).map(input => input.value)
      : [];
    const variant = selectedOptions.length
      ? variants.find(item => item.options?.every((value, index) => value === selectedOptions[index]))
      : variants.find(item => String(item.id) === String(idInput?.value));
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price);
    const isEn = document.documentElement.lang === 'en';
    const isSale = !isEn && Boolean(variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price));
    if (compare) {
      compare.textContent = isSale ? formatMoney(variant.compare_at_price) : '';
      compare.hidden = !isSale;
    }
    const priceBadge = section.querySelector('[data-product-price-badge]');
    if (priceBadge) {
      priceBadge.hidden = !isSale;
    }
    const imageSaleBadge = section.querySelector('[data-product-image-sale-badge]') || document.querySelector('[data-product-image-sale-badge]');
    if (imageSaleBadge) {
      imageSaleBadge.hidden = !(isSale && variant.available);
    }
    const inStock = variant.available && stock[String(variant.id)] === true;
    const isKo = document.documentElement.lang === 'ko';

    if (inventory) { inventory.textContent = inStock ? (isEn ? 'In stock' : (isKo ? '재고 있음' : '在庫あり')) : (isEn ? (variant.available ? 'Available to order' : 'Out of stock') : (isKo ? '현재 품절' : '現在在庫切れ')); }
    if (leadtime) {
      leadtime.hidden = !inStock;
      leadtime.textContent = inStock ? (isEn ? 'In stock' : (isKo ? '재고 있음 ｜ 통상 1〜2영업일 이내 발송' : '在庫あり｜通常1〜2営業日以内に発送')) : '';
    }
    if (stickyPrice && variant) {
      stickyPrice.textContent = formatMoney(variant.price);
    }
    if (stickyCta && !variant.available) {
      stickyCta.classList.remove('is-visible');
      stickyCta.setAttribute('aria-hidden', 'true');
    }
    if (button) { button.disabled = !variant.available; button.textContent = variant.available ? (isEn ? 'Add to cart' : 'カートに追加') : (isEn ? 'Sold out' : '売り切れ'); }
    quantityBlock?.querySelectorAll('button, input').forEach(control => { control.disabled = !variant.available; });
    if (paymentBlock) paymentBlock.hidden = !variant.available;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };
  optionInputs.forEach(input => input.addEventListener('change', updateVariant));
  updateVariant();
  form?.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
  form?.querySelector('[data-quantity-increase]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });

  if (stickyCta && button) {
    stickyButton?.addEventListener('click', event => {
      event.preventDefault();
      if (!button.disabled) button.click();
    });
    const syncButtonState = () => {
      if (!stickyButton) return;
      stickyButton.disabled = button.disabled;
      stickyButton.textContent = button.textContent;
    };
    if (window.MutationObserver) {
      new MutationObserver(syncButtonState).observe(button, { attributes: true, childList: true, characterData: true });
    }
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const isOriginalVisible = entry.isIntersecting;
          stickyCta.classList.toggle('is-visible', !isOriginalVisible);
          stickyCta.setAttribute('aria-hidden', String(isOriginalVisible));
        });
      }, { threshold: 0.1 });
      observer.observe(button);
    } else {
      stickyCta.classList.add('is-visible');
      stickyCta.setAttribute('aria-hidden', 'false');
    }
  }
}
document.querySelectorAll('[data-product-section]').forEach(initProductDetail);
document.addEventListener('shopify:section:load',event=>{const section=event.target.matches?.('[data-product-section]')?event.target:event.target.querySelector?.('[data-product-section]');initProductDetail(section);});
